<template>
  <main>
    <section class="prev-page-section" style="background-image:url(/static-assets/img/contact-img.jpg);">
      <div class="container">
        <div class="grey-title-block resp-number">404 Not Found</div>
      </div>
    </section>
  </main>
</template>

<script>

export default {
  name: 'NotFound'
}

</script>

<style scoped>
    @media screen and (max-width: 576px) {
        .resp-number {
            display: block;
        }
    }
</style>
